// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Summary_shadow__UOZtv","summary":"Summary_summary__1i0Kg","header":"Summary_header__3vQki","tabContainer":"Summary_tabContainer__2-1d0"};